import { VariableType } from '@/proto/common';

/**
 * Friendly label for each VariableType, shown as a type hint in variable
 * pickers. STRING/TEXT are omitted — plain text is the implied default, so
 * labeling it would just add noise to the dropdown.
 */
const NODE_VARIABLE_TYPE_LABELS: Partial<Record<VariableType, string>> = {
  [VariableType.NUMBER]: 'Number',
  [VariableType.BOOL]: 'Boolean',
  [VariableType.DATE_TIME]: 'Date & time',
  [VariableType.DATE_TIME_RANGE]: 'Date & time range',
  [VariableType.SHIPMENT]: 'Shipment',
  [VariableType.ALERT]: 'Alert',
  [VariableType.ALERT_TYPE]: 'Alert type',
  [VariableType.TRANSPORT_PROVIDER]: 'Transport provider',
};

/** Returns undefined for Text/String, since that's the implied default type. */
export function getVariableTypeLabel(
  type: VariableType | number
): string | undefined {
  return NODE_VARIABLE_TYPE_LABELS[type as VariableType];
}

/**
 * Generic representative value per type, used when a variable has no
 * type-specific sample value of its own (e.g. a user variable sourced from a
 * collect-catalog entry that predates sample values). Returns undefined for
 * Text/String — there's no single generic value that's a meaningful filler
 * for free text, so callers should fall back to something else (e.g. the
 * `{variable_name}` placeholder).
 */
const GENERIC_EXAMPLE_BY_TYPE: Partial<Record<VariableType, string>> = {
  [VariableType.NUMBER]: '42',
  [VariableType.BOOL]: 'true',
  [VariableType.DATE_TIME]: 'Jul 4, 3:45 PM',
  [VariableType.DATE_TIME_RANGE]: 'Jul 4, 3:45 PM - Jul 4, 5:00 PM',
};

export function getGenericExampleForType(
  type: VariableType | number
): string | undefined {
  return GENERIC_EXAMPLE_BY_TYPE[type as VariableType];
}
